import { render, staticRenderFns } from "./RenameOrgObject.vue?vue&type=template&id=6201807a"
import script from "./RenameOrgObject.vue?vue&type=script&lang=js"
export * from "./RenameOrgObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports